<template>
  <div>
    <v-bottom-sheet
      v-model="sheet"
      z-index="214"
      :fullscreen="expanded"
      :inset="!expanded"
    >
      <v-card
        style="
          border-radius: 10px 10px 0 0;
          border-left: 1px solid #272727;
          border-right: 3px solid #272727;
          border-top: 1px solid #272727;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
        "
      >
        <v-sheet
          color="smokeDark"
          class="px-4 py-2 d-flex align-center justify-space-between"
        >
          <div class="d-flex align-center" style="gap: 10px">
            <span style="font-size: 12pt; font-weight: 600"
              ><v-icon v-if="status == 'suggested'" size="16" class="mr-2"
                >mdi-creation</v-icon
              >Post</span
            >
            <div>&mdash;</div>
            <v-menu>
              <template v-slot:activator="{ props: menu }">
                <v-btn
                  :icon="category === null ? true : false"
                  :size="category === null ? 'x-small' : 'small'"
                  variant="tonal"
                  v-bind="menu"
                  ><v-icon :class="category ? 'mr-1' : ''"
                    >mdi-folder-outline</v-icon
                  >
                  <span
                    :style="
                      category
                        ? 'text-decoration: underline; text-underline-offset: 2px;'
                        : ''
                    "
                    v-if="category"
                  >
                    {{ category ? `${category.name}` : "" }}
                  </span>
                </v-btn>
              </template>
              <v-list density="compact">
                <v-list-item
                  v-for="(item, index) in categories.filter(
                    (c) => c.status !== 'suggested',
                  )"
                  :key="index"
                  :value="index"
                  @click="category = item"
                >
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="category = null">
                  <v-list-item-title
                    ><v-icon size="12" class="mr-1">mdi-close</v-icon>
                    None</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>

            <v-tooltip>
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  size="x-small"
                  variant="tonal"
                  :icon="
                    recurring
                      ? 'mdi-repeat-variant'
                      : 'mdi-numeric-1-circle-outline'
                  "
                  @click="recurring = !recurring"
                ></v-btn>
              </template>
              <div>
                <p class="text-white">
                  {{ recurring ? "Recurring" : "One-time" }}
                </p>
              </div>
            </v-tooltip>

            <div>
              <v-menu
                transition="slide-y-transition"
                bottom
                offset-x
                :close-on-content-click="false"
                v-model="menuSchedule"
              >
                <template v-slot:activator="{ props: menuSchedule }">
                  <v-btn
                    :icon="schedule_date === null"
                    :size="schedule_date === null ? 'x-small' : 'small'"
                    variant="tonal"
                    v-bind="menuSchedule"
                    ><v-icon>mdi-calendar-outline</v-icon
                    ><span v-if="schedule_date">Scheduled: </span>
                    {{
                      schedule_date ? getTimestamp(schedule_date) : ""
                    }}</v-btn
                  >
                </template>
                <v-card>
                  <div class="px-4 pt-4">
                    <div class="bg-smoke">
                      <v-date-picker
                        @update:model-value="changeScheduleDate"
                        hide-header="true"
                        :model-value="
                          schedule_date
                            ? getTimestampJSDate(schedule_date)
                            : null
                        "
                      ></v-date-picker>
                    </div>
                  </div>
                  <div class="px-4 pb-4">
                    <v-text-field
                      type="time"
                      label="Time"
                      variant="solo"
                      flat
                      bg-color="smoke"
                      style="border-radius: 6px"
                      hide-details
                      :model-value="
                        schedule_date ? getTimeString(schedule_date) : null
                      "
                      @update:model-value="changeScheduleTime"
                    ></v-text-field>
                  </div>
                  <v-divider></v-divider>
                  <div class="pa-1 d-flex align-center">
                    <v-btn
                      block
                      variant="text"
                      @click="
                        schedule_date = null;
                        menuSchedule = false;
                      "
                      >Remove schedule</v-btn
                    >
                  </div>
                </v-card>
              </v-menu>
            </div>

            <div>
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn v-bind="props" icon size="x-small" variant="tonal">
                    <v-icon
                      :color="auto_variation ? 'primary' : 'muted'"
                      size="16"
                      >mdi-rotate-3d-variant</v-icon
                    >
                  </v-btn>
                </template>
                <v-list density="compact">
                  <v-list-item
                    @click="
                      auto_variation = true;
                      auto_variation_level = 'light';
                    "
                  >
                    <v-list-item-title
                      ><v-icon
                        class="mr-2"
                        size="16"
                        color="primary"
                        v-if="auto_variation_level === 'light'"
                        >mdi-check</v-icon
                      >Light changes</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    @click="
                      auto_variation = true;
                      auto_variation_level = 'medium';
                    "
                  >
                    <v-list-item-title
                      ><v-icon
                        class="mr-2"
                        size="16"
                        color="primary"
                        v-if="auto_variation_level === 'medium'"
                        >mdi-check</v-icon
                      >Medium changes</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    @click="
                      auto_variation = true;
                      auto_variation_level = 'heavy';
                    "
                  >
                    <v-list-item-title
                      ><v-icon
                        class="mr-2"
                        size="16"
                        color="primary"
                        v-if="auto_variation_level === 'heavy'"
                        >mdi-check</v-icon
                      >Heavy changes</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    @click="
                      auto_variation = true;
                      auto_variation_level = 'auto';
                    "
                  >
                    <v-list-item-title
                      ><v-icon
                        class="mr-2"
                        size="16"
                        color="primary"
                        v-if="auto_variation_level === 'auto'"
                        >mdi-check</v-icon
                      >Automatic variations</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item @click="auto_variation = false">
                    <v-list-item-title
                      ><v-icon
                        class="mr-2"
                        size="16"
                        color="primary"
                        v-if="!auto_variation"
                        >mdi-check</v-icon
                      >Manual variations</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div>
              <v-tooltip v-if="statistics">
                <template v-slot:activator="{ props }">
                  <v-btn size="small" variant="tonal" icon v-bind="props">
                    <v-icon size="16" color="primary">mdi-chart-bar</v-icon>
                  </v-btn>
                </template>
                <div>
                  <p class="text-white mb-1 font-weight-medium">Statistics</p>
                  <p class="text-white">
                    {{ statistics?.engagementRate }}% engagement rate
                  </p>
                  <p class="text-white">{{ statistics?.likes }} likes</p>
                  <p class="text-white">{{ statistics?.comments }} comments</p>
                  <p class="text-white">{{ statistics?.shares }} shares</p>
                  <p class="text-white">
                    {{ statistics?.impressions }} impressions
                  </p>
                  <p class="text-white">{{ statistics?.clicks }} clicks</p>
                  <p class="text-white">
                    {{ statistics?.uniqueImpressions }} unique impressions
                  </p>
                </div>
              </v-tooltip>
            </div>
          </div>
          <div
            v-if="status != 'suggested'"
            style="width: 100px; gap: 15px"
            class="d-flex justify-end align-center"
          >
            <div>
              <v-btn
                v-if="!post"
                variant="text"
                color="primary"
                @click="$store.dispatch('clearPost')"
                >Clear</v-btn
              >
              <v-btn
                v-else
                icon="mdi-delete"
                size="small"
                variant="text"
                color="primary"
                @click="deletePost"
              ></v-btn>
            </div>

            <v-menu transition="slide-x-transition" bottom offset-x>
              <template v-slot:activator="{ props }">
                <div
                  :style="{
                    borderBottom: '3px solid #272727',
                    borderLeft: '1px solid #272727',
                    borderTop: '1px solid #272727',
                    borderRight: '3px solid #272727',
                    borderRadius: '6px',
                  }"
                >
                  <v-btn
                    :width="$vuetify.display.smAndDown ? ' 48%' : ''"
                    :style="{
                      'font-size': $vuetify.display.smAndDown ? '12px' : '',
                    }"
                    style="min-width: 100px"
                    v-bind="props"
                    color="button"
                    size="small"
                    elevation="0"
                    :loading="saving"
                    :disabled="saving || thinking"
                    ><span class="pl-4">Save</span
                    ><v-icon id="chevron" class="ml-4">mdi-chevron-down</v-icon>
                  </v-btn>
                </div>

                <v-btn
                  variant="text"
                  v-if="mode === 'carousel'"
                  @click="expanded = !expanded"
                  :icon="expanded ? 'mdi-arrow-collapse' : 'mdi-arrow-expand'"
                ></v-btn>
              </template>
              <!-- TODO remove button 2 and 3 if user does not have permissions to publish, add another button 'request publish'  -->
              <v-list>
                <!-- IF EXISTING POST -->

                <!-- <div v-if="post && last_publish && !recurring">
                  <v-list-item
                    link
                    class="px-4 py-2"
                    @click="duplicatePost"
                    title="Save as duplicate"
                    subtitle="This post has been published before. Saving as a duplicate will create a new post with the same content."
                  >
                  </v-list-item>
                </div> -->
                <div v-if="post">
                  <v-list-item
                    link
                    class="px-4 py-2"
                    @click="savePost(schedule_date, status)"
                    title="Save changes"
                    subtitle="Post will be saved with the current schedule and status."
                  >
                  </v-list-item>
                  <v-list-item
                    link
                    v-if="status !== 'draft'"
                    class="px-4 py-2"
                    @click="savePost(null, 'draft')"
                    title="Save as draft"
                    subtitle="Post will be saved as a draft and can be published later."
                  >
                  </v-list-item>
                  <v-list-item
                    @click="savePost(null, 'active')"
                    link
                    class="px-4 py-2"
                    v-if="!schedule_date && status === 'draft'"
                    title="Automatic scheduling"
                    subtitle="Post will be scheduled automatically in the schedule."
                  >
                  </v-list-item>

                  <v-list-item
                    v-if="!schedule_date"
                    link
                    class="px-4 py-2"
                    @click="savePost('now', 'active')"
                    title="Publish now"
                    subtitle="Post will be published immediately."
                  >
                  </v-list-item>
                  <v-list-item
                    title="Publish later"
                    :subtitle="
                      schedule_date
                        ? 'Post will be published at the scheduled time.'
                        : 'Select a date and time to publish later.'
                    "
                    @click="
                      schedule_date
                        ? savePost(schedule_date, 'active')
                        : (menuSchedule = true)
                    "
                    link
                    class="px-4 py-2"
                  >
                  </v-list-item>
                </div>

                <!-- IF NEW -->
                <div v-else>
                  <v-list-item
                    link
                    class="px-4 py-2"
                    @click="savePost(null, 'draft')"
                    title="Save as draft"
                    subtitle="Post will be saved as a draft and can be published later."
                  >
                  </v-list-item>
                  <v-list-item
                    @click="savePost(null, 'active')"
                    link
                    class="px-4 py-2"
                    title="Automatic scheduling"
                    subtitle="Post will be scheduled automatically in the schedule."
                  >
                  </v-list-item>
                  <v-list-item
                    link
                    class="px-4 py-2"
                    title="Publish now"
                    subtitle="Post will be published immediately."
                    @click="savePost('now', 'active')"
                  >
                  </v-list-item>
                  <v-list-item
                    link
                    class="px-4"
                    @click="
                      schedule_date
                        ? savePost(schedule_date, 'active')
                        : (menuSchedule = true)
                    "
                    title="Publish later"
                    :subtitle="
                      schedule_date
                        ? 'Post will be published at the scheduled time.'
                        : 'Select a date and time to publish later.'
                    "
                  >
                  </v-list-item>
                  <!-- <v-list-item link class="px-4" @click="add(null, 'review')">
              <v-list-item-title>Save for review</v-list-item-title>
            </v-list-item> -->
                </div>
              </v-list>
            </v-menu>
          </div>
          <div
            v-if="status == 'suggested'"
            class="d-flex justify-end"
            style="gap: 10px"
          >
            <v-btn
              style="
                border-left: 1px solid #272727;
                border-right: 3px solid #272727;
                border-top: 1px solid #272727;
                border-bottom: 3px solid #272727;
                border-radius: 6px;
              "
              variant="flat"
              color="button"
              @click="keepPost"
              >Keep</v-btn
            >
            <v-btn variant="text" color="primary" @click="rejectPost"
              >Discard</v-btn
            >
          </div>
        </v-sheet>
        <v-divider></v-divider>

        <div
          class="editor"
          :style="{
            'grid-template-columns': showChat
              ? '1fr repeat(2, minmax(0, 2fr))'
              : 'repeat(2, minmax(0, 1fr))',
          }"
        >
          <div
            style="width: 100%; border-right: 1px solid #e0e0e0"
            v-if="showChat"
          >
            <MessagesView @useSource="useSource" />
          </div>

          <div
            style="
              position: relative;
              z-index: 1;
              width: 100%;
              border-right: 1px solid #e0e0e0;
            "
          >
            <div>
              <v-tabs-window v-model="tab">
                <v-tabs-window-item
                  v-for="(item, index) in variations"
                  :key="index"
                  :value="'tab-' + index"
                >
                  <linkedinPostEditor
                    v-if="tab !== null && variations && variations[tab]"
                    v-model="variations[tab].text"
                    :disabled="
                      (variations[tab] && variations[tab].loading) || loading
                    "
                  />
                </v-tabs-window-item>
              </v-tabs-window>
            </div>
          </div>

          <div
            class="d-flex align-center justify-center"
            style="overflow: hidden; min-height: 0"
          >
            <div
              v-if="
                !media ||
                media.length === 0 ||
                addMedia ||
                mode === 'template' ||
                mode === 'carousel'
              "
              style="height: 100%; width: 100%"
            >
              <MediaEditor
                ref="mediaEditor"
                @preview="setPreview"
                @selectMedia="selectMedia"
              />
            </div>

            <MediaView
              v-else
              @addMedia="
                addMedia = true;
                $nextTick(() => {
                  if ($refs.mediaEditor) {
                    $refs.mediaEditor.selectMode('image');
                  }
                });
              "
            />
          </div>

          <v-card
            variant="flat"
            class="bg-smoke"
            style="
              border-radius: 0px;
              border-top: 1px solid #e0e0e0;
              width: 100%;
              grid-column: span 3;
              height: 160px;
            "
            :loading="loading || thinking"
          >
            <div
              class="d-flex align-center px-2 pt-2 flex-wrap justify-space-between"
              style="gap: 8px"
            >
              <div class="d-flex align-center" style="gap: 5px">
                <v-btn
                  rounded
                  size="x-small"
                  variant="tonal"
                  @click="applyTone"
                >
                  Apply brand tone
                </v-btn>
                <v-btn
                  rounded
                  size="x-small"
                  variant="tonal"
                  @click="applyInstructions('Shorten the post')"
                >
                  Shorten
                </v-btn>
                <v-btn
                  size="x-small"
                  variant="tonal"
                  rounded
                  @click="applyInstructions('Lengthen the post')"
                >
                  Lengthen
                </v-btn>
                <v-btn
                  v-if="current_variation.text.length > 0"
                  rounded
                  size="x-small"
                  variant="tonal"
                  @click="
                    applyInstructions('Convert my post to a PDF carousel')
                  "
                >
                  Generate carousel
                </v-btn>
                <v-btn
                  size="x-small"
                  variant="tonal"
                  rounded
                  v-if="media && media.length === 1 && media[0].type === 'url'"
                  >Write about article</v-btn
                >
                <v-btn
                  size="x-small"
                  variant="tonal"
                  rounded
                  v-if="
                    media && media.length === 1 && media[0].extension === 'pdf'
                  "
                  >Write about PDF</v-btn
                >
              </div>
            </div>
            <v-form @submit.prevent class="d-flex align-center">
              <v-textarea
                ref="floatingInputField"
                v-model="floatingInput"
                placeholder="Let's write together!"
                hide-details
                flat
                rows="3"
                variant="solo"
                bg-color="transparent "
                :disabled="loading || thinking"
                autocomplete="off"
                @keydown.enter="sendMessage"
                class="floating-text-field text-caption"
                density="comfortable"
              >
              </v-textarea>
            </v-form>
            <div class="d-flex justify-space-between align-center">
              <div class="px-2 d-flex align-center" style="gap: 5px">
                <v-btn
                  :prepend-icon="
                    showChat
                      ? 'mdi-arrow-collapse-right'
                      : 'mdi-arrow-collapse-left'
                  "
                  variant="tonal"
                  @click="showChat = !showChat"
                  size="x-small"
                  color="faded"
                  >{{ showChat ? "Hide" : "Show" }} chat</v-btn
                >
                <v-tooltip
                  location="bottom"
                  max-width="200"
                  :text="`${workspace?.counter?.tokens} tokens available of 5M tokens.`"
                >
                  <template #activator="{ props }">
                    <v-chip size="x-small" variant="text" v-bind="props">
                      {{ tokenUsed }}%
                      <v-progress-circular
                        class="ml-1"
                        color="primary"
                        size="14"
                        width="2"
                        :model-value="tokenUsed"
                      ></v-progress-circular>
                    </v-chip>
                  </template>
                </v-tooltip>
                <!-- <v-menu>
                  <template v-slot:activator="{ props: menu }">
                    <v-btn size="x-small" variant="tonal" v-bind="menu"
                      >Structure
                      <span v-if="structure">: </span>
                      <span
                        :style="
                          structure
                            ? 'text-decoration: underline; text-underline-offset: 2px;'
                            : ''
                        "
                      >
                        {{ structure ? `${structure.title}` : "" }}
                      </span>
                    </v-btn>
                  </template>
                  <v-list density="compact">
                    <v-list-item
                      v-for="(item, index) in structures"
                      :key="index"
                      :value="index"
                      @click="structure = item"
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="structure = null">
                      <v-list-item-title
                        ><v-icon size="12" class="mr-1">mdi-close</v-icon>
                        None</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu> -->
              </div>

              <div style="gap: 2px" class="d-flex">
                <!-- <v-btn
                    icon="mdi-file-plus"
                    size="small"
                    variant="default"
                  ></v-btn> -->
                <v-btn
                  :disabled="floatingInput.trim() === '' || loading || thinking"
                  @click="sendMessage"
                  icon="mdi-arrow-up-circle"
                  variant="text"
                ></v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { post } from "@/mixins/post";
import LinkedinPostEditor from "@/components/LinkedinPostEditor.vue";
import { mapState } from "vuex";
import MediaView from "@/components/media/MediaView.vue";
import MessagesView from "@/components/messagesView.vue";
// import TemplateCard from "@/components/media/TemplateCard.vue";
import MediaEditor from "@/components/media/MediaEditor.vue";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { agent } from "@/mixins/agent";
import { DateTime } from "luxon";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      accounts: (state) => state.accounts.accounts,
      categories: (state) => state.posts.categories,
      posts: (state) => state.posts.posts,
      workspace: (state) => state.workspace.workspace,
      structures: (state) => state.structures.structures,
      brand: (state) => state.workspace.brand,
    }),
    tokenUsed() {
      if (!this.workspace?.counter.tokens) return 0;
      return Math.round((this.workspace.counter.tokens / 2000000) * 100);
    },
    showChat: {
      get() {
        return this.$store.state.agent.showChat;
      },
      set(value) {
        this.$store.commit("setShowChat", value);
      },
    },
    mode: {
      get() {
        return this.$store.state.post.mode;
      },
      set(value) {
        this.$store.commit("setPostMode", value);
      },
    },
    expanded: {
      get() {
        return this.$store.state.post.expanded;
      },
      set(value) {
        this.$store.commit("setPostExpanded", value);
      },
    },
  },
  mixins: [post, agent],
  components: {
    LinkedinPostEditor,
    MediaView,
    MessagesView,
    // TemplateCard,
    MediaEditor,
  },
  data() {
    return {
      floatingInput: "",
      addMedia: false,
      conversation_id: null,
      menuSchedule: false,
    };
  },
  methods: {
    async getPostStatistics() {
      const getPostStatistics = httpsCallable(functions, "getPostStatistics");
      const res = await getPostStatistics({
        postUrn: this.urn,
        account: this.accounts[0].id,
        workspace: this.workspace.uid,
      });
      console.log(res.data);
    },
    getTimestampJSDate(timestamp) {
      return DateTime.fromSeconds(timestamp)
        .setZone(this.workspace.timezone)
        .toJSDate();
    },
    getTimestamp(timestamp) {
      return DateTime.fromSeconds(timestamp)
        .setZone(this.workspace.timezone)
        .toFormat("dd/MM/yyyy HH:mm");
    },
    getTimeString(timestamp) {
      return DateTime.fromSeconds(timestamp)
        .setZone(this.workspace.timezone)
        .toFormat("HH:mm");
    },
    changeScheduleTime(value) {
      if (!value) return;
      const [hour, minute] = value.split(":").map((n) => parseInt(n, 10));
      let base = this.schedule_date
        ? DateTime.fromSeconds(this.schedule_date).setZone(
            this.workspace.timezone,
          )
        : DateTime.now().setZone(this.workspace.timezone);
      base = base.set({ hour, minute, second: 0, millisecond: 0 });
      this.schedule_date = Math.floor(base.toSeconds());
    },
    async deletePost() {
      let r = window.confirm("Are you sure to delete this post?");
      if (!r) {
        return;
      }
      if (!this.post) {
        this.$store.commit("clearPost");
      } else {
        this.$store.commit("setLoading", { type: "general", val: true });
        const deletePost = httpsCallable(functions, "postDelete");
        await deletePost(this.post);
        this.$store.dispatch("fetchPosts");
      }

      this.$store.commit("setLoading", { type: "general", val: false });
      // this.$router.push("/library");
      this.sheet = false;
      this.$store.commit("setNotification", {
        show: true,
        text: "Your post has been deleted!",
        type: "primary",
        icon: "delete",
      });
    },
    applyInstructions(text) {
      this.floatingInput = text;
      this.sendMessage();
    },
    async applyTone() {
      this.loading = true;
      console.log(this.brand);
      const applyTone = httpsCallable(functions, "applyTone");
      const result = await applyTone({
        post: this.variations[this.tab].text,
        tone_of_voice: this.brand?.voice || "",
      });
      console.log(result.data);
      this.variations[this.tab].text = result.data;
      this.loading = false;
    },
    async useSource(source) {
      console.log("Getting link preview");
      console.log(source);
      source.loading = true;
      const getPreview = httpsCallable(functions, "getLinkPreview");
      const res = await getPreview({
        url: source.url,
      });
      console.log(res.data);
      this.media = [
        {
          alt: res.data.images,
          type: "url",
          url: res.data.url,
          src: res.data.image,
          description: res.data.description,
          language: res.data.language,
          title: res.data.title,
        },
      ];
      source.loading = false;
    },
    linkify(t) {
      if (!t) return "";
      return t
        .replace(/(https?:\/\/[^\s<>"')]+|www\.[^\s<>"')]+)/gi, (m) => {
          // strip trailing punctuation
          const clean = m.replace(/[).,!?:]+$/, "");
          const href = clean.startsWith("http") ? clean : `https://${clean}`;
          return `<a href="${href}" target="_blank" rel="noopener noreferrer">${clean}</a>`;
        })
        .replace(/\n/g, "<br>");
    },
    sendMessage() {
      if (this.floatingInput.trim() && !this.loading) {
        this.$store.dispatch("AddChatMessage", this.floatingInput);
        this.floatingInput = "";
      }
    },
    async sendChatMessage() {
      try {
        this.loading = true;
        const chat = httpsCallable(functions, "chat");
        let body = {
          draft: this.variations[this.tab].text,
          message: this.floatingInput,
          conversation_id: this.conversation_id,
        };
        if (this.media[0]?.type === "url") {
          body.url = this.media[0].url;
        }
        console.log(body);
        const result = await chat(body);
        console.log(result.data);
        this.conversation_id = result.data.conversation_id;
        this.floatingInput = "";

        console.log(JSON.parse(result.data.response));
        this.variations[this.tab].text = JSON.parse(
          result.data.response,
        ).postContent;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    selectMedia(file) {
      this.media.push(file);
      this.addMedia = false;
    },
    setPreview(v) {
      this.media = [
        {
          alt: v.images,
          type: "url",
          url: v.url,
          src: v.image,
          description: v.description,
          language: v.language,
          title: v.title,
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
.editor {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: 1fr auto;
  flex: 1;
  min-height: 0;
  transition: all 0.3s ease;
}
::v-deep .v-textarea textarea {
  font-size: 10pt !important;
}
</style>
